import { useMutation } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

import { axios } from "@/client/libs/axios";

export type UploadedDocumentLink = {
  name: string;
  type: string;
  url: string;
};

export const uploadDocument = async (file: File) => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await axios.put<
    UploadedDocumentLink,
    AxiosResponse<UploadedDocumentLink>,
    FormData
  >("/storage/document", formData, { headers: { "Content-Type": "multipart/form-data" } });

  return response.data;
};

export const useUploadDocument = () => {
  const {
    error,
    isPending: loading,
    mutateAsync: uploadDocumentFn,
  } = useMutation({
    mutationFn: uploadDocument,
  });

  return { uploadDocument: uploadDocumentFn, loading, error };
};
